import { ControlType, Property, PropertyType } from "../../../base/types";

import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import clsx from "clsx";
import { useGetProperties } from "../../../base/hooks";

export const TwitterComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const screenName: string | undefined = properties[Property.ScreenName];
    const height: string | undefined = properties[Property.Height];
    const tooltip: string | undefined = properties[Property.Tooltip];

    return (
        <div className={clsx("position-relative overflow-scroll", className)} title={tooltip}>
            {screenName && <TwitterTimelineEmbed
                sourceType="profile"
                screenName={screenName}
                options={{ height: height || 300 }}
            />}
        </div>
    )
}

Registry.addControl({
    id: "3caf0e35-048f-4f68-95fc-26d998e89a5d",
    name: "Twitter",
    type: ControlType.Twitter,
    properties: [
        { id: Property.ScreenName, name: 'Screen Name', type: PropertyType.String },
        { id: Property.Height, name: 'Height', type: PropertyType.Number },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: TwitterComponent
})
